import { useParams } from 'react-router-dom';
import { Commentable } from '@/shared/comments/Commentable';
import { HelpAnchor } from '@/design-system/HelpAnchor';
import { SURFACE_PAGE_WIDTH_NARROW } from '@/shared/ui-class';

export function SettingsPlaceholderScene() {
  const { slug } = useParams<{ slug: string }>();

  return (
    <Commentable name="SettingsPlaceholderScene">
      <div className={`flex-1 overflow-y-auto py-8 ${SURFACE_PAGE_WIDTH_NARROW}`}>
        <div className="mb-4 flex items-center justify-between gap-4">
          <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100">
            Settings
          </h1>
          <HelpAnchor doc="workspace/sidebar" />
        </div>
        <p className="text-sm text-muted">
          <span className="font-medium text-zinc-900 dark:text-zinc-100">
            /settings/{slug ?? '…'}
          </span>{' '}
          — coming in Phase 4.
        </p>
      </div>
    </Commentable>
  );
}
